import { KanbanPassengerDragSlotEnum } from "@ryde/shared";

export const getKanbanPassengerDragSlot = ({
  isPassengerDraggable,
  isDragClone,
  hasScopeRestrictions,
}: {
  isPassengerDraggable: boolean;
  isDragClone?: boolean;
  hasScopeRestrictions: boolean;
}): KanbanPassengerDragSlotEnum => {
  if (isPassengerDraggable && !isDragClone) {
    return KanbanPassengerDragSlotEnum.Grip;
  }

  if (hasScopeRestrictions && !isDragClone) {
    return KanbanPassengerDragSlotEnum.Restriction;
  }

  return KanbanPassengerDragSlotEnum.Placeholder;
};
